/* eslint-disable @typescript-eslint/camelcase */
import { Array, Record, Static, Number, Function } from 'runtypes'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import styles from './Comments.module.scss'
import SingleComment from '../SingleComment/SingleComment'
import AddComment from '../AddComment/AddComment'
import {
  CommentsPagination,
  CommentWithChildren,
} from '../../../../types/comment'
import { CommentsApi } from '../../../../api/comments'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Post } from '../../../../types'
import { actions } from '../../../../store'

export const CommentsResponse = Record({
  current_page: Number,
  data: Array(CommentWithChildren),
  from: Number,
  lastPage: Number,
})
export const CommentProps = Record({
  post: Post,
  commentsPagination: CommentsPagination,
  updateCommentsPagination: Function,
  newCommentAdded: Function,
  toggleShowSubComments: Function,
})
export type CommentsResponse = Static<typeof CommentsResponse>
export type CommentProps = Static<typeof CommentProps>

const Comments = ({
  post,
  commentsPagination,
  updateCommentsPagination,
  newCommentAdded,
  toggleShowSubComments,
}: CommentProps) => {
  const [showAllComments, setShowAllComments] = useState(false)
  const [commentsToShow, setCommentsToShow] = useState([])
  useEffect(() => {
    showAllComments
      ? setCommentsToShow(commentsPagination.comments)
      : setCommentsToShow(commentsPagination.comments.slice(0, 3))
  }, [...Object.keys(commentsPagination.comments.length), showAllComments])

  const addCommentHandler = async (
    comment: string,
    parentId = null,
    username?: string,
    email?: string
  ) => {
    const response = await CommentsApi.leaveComment(
      post.slug,
      comment,
      parentId,
      username,
      email
    )
    if (response.status !== 200) {
      return response.data.error
    }
    newCommentAdded({
      comment: response.data.comment,
      id: response.data.id,
      parent_comment_id: response.data.parent_comment_id,
      author: response.data.user.name,
      created_at: moment(),
      childs: [],
      total_likes: 0,
      total_dislike: 0,
      total_rel_likes_count: 0,
      total_rel_dislikes_count: 0,
    })
  }

  const fetchMoreComments = async () => {
    const perPage = 20
    if (commentsPagination.page * perPage < commentsPagination.total) {
      const commentsResponse = await CommentsApi.getByPostSlug(
        post.slug,
        commentsPagination.page + 1,
        perPage,
        null
      )
      updateCommentsPagination(
        commentsResponse?.data.data,
        commentsResponse?.data.current_page
      )
    }
  }

  const formatShowSubCommentsButtonText = (comment) => {
    if (comment.childs.lengt === 1) {
      return (
        <span className="flex">
          <svg
            viewBox="0 0 24 24"
            preserveAspectRatio="xMidYMid meet"
            focusable="false"
            width={20}
            className="style-scope yt-icon"
          >
            <g className="style-scope yt-icon">
              <path d="M7 10l5 5 5-5z" className="style-scope yt-icon"></path>
            </g>
          </svg>
          <span>Prikaži 1 odgovor</span>
        </span>
      )
    } else if (comment.childs.length) {
      return (
        <span className="flex">
          <svg
            viewBox="0 0 24 24"
            preserveAspectRatio="xMidYMid meet"
            focusable="false"
            width={20}
            className="style-scope yt-icon"
          >
            <g className="style-scope yt-icon">
              <path d="M7 10l5 5 5-5z" className="style-scope yt-icon"></path>
            </g>
          </svg>
          <span>{`Prikaži ${comment.childs.length} odgovora`}</span>
        </span>
      )
    }
    return null
  }

  const formatHideSubCommentsButtonText = (comment) => {
    if (comment.childs.lengt === 1) {
      return (
        <span className="flex">
          <svg
            viewBox="0 0 24 24"
            width={20}
            preserveAspectRatio="xMidYMid meet"
            focusable="false"
            className="style-scope yt-icon"
          >
            <g className="style-scope yt-icon">
              <path d="M7 14l5-5 5 5z" className="style-scope yt-icon"></path>
            </g>
          </svg>
          <span>Sakrij 1 odgovor</span>
        </span>
      )
    }
    return (
      <span className="flex">
        <svg
          viewBox="0 0 24 24"
          width={20}
          preserveAspectRatio="xMidYMid meet"
          focusable="false"
          className="style-scope yt-icon"
        >
          <g className="style-scope yt-icon">
            <path d="M7 14l5-5 5 5z" className="style-scope yt-icon"></path>
          </g>
        </svg>
        <span>{`Sakrij ${comment.childs.length} odgovora`}</span>
      </span>
    )
  }

  return (
    <div
      className={`${styles.comments} mt-8 px-2.5 px-0 md:pl-0 h-auto bg-white`}
    >
      <div className={`${styles.header} flex items-center justify-between`}>
        <p className="md:w-3/4 flex items-center">
          <svg
            className={`${styles.messageIcon} w-8`}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            height={36}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
            />
          </svg>
          <span className={`${styles.numberOfComments} ml-2 lg:ml-4`}>
            {`Poslednji komentari (${commentsPagination.total})`}
          </span>
        </p>
        <p
          className={`${styles.numberOfCommentsToShow} w-1/4 text-gold font-semibold text-right cursor-pointer`}
          onClick={() => setShowAllComments(!showAllComments)}
        >
          {showAllComments ? (
            <span>Prikaži manje</span>
          ) : (
            <span>Svi komentari</span>
          )}
        </p>
      </div>
      <div>
        <InfiniteScroll
          dataLength={commentsToShow.length}
          next={fetchMoreComments}
          hasMore={
            showAllComments &&
            commentsPagination.comments.length < commentsPagination.total
          }
          loader={null}
        >
          {showAllComments
            ? commentsPagination.comments
                .sort(function (a, b) {
                  return (
                    moment(b.created_at).unix() - moment(a.created_at).unix()
                  )
                })
                .reverse()
                .map((comment) => {
                  return (
                    <div key={comment.id}>
                      <SingleComment
                        post={post}
                        key={`single-comment-${comment.id}`}
                        comment={comment}
                        isChildComment={false}
                        addCommentHandler={addCommentHandler}
                      />
                      {comment && comment.childs && comment.childs.length
                        ? comment.childs.map((child) => {
                            return (
                              <div
                                className="flex items-center"
                                key={`child-comment-${child.id}`}
                              >
                                <SingleComment
                                  post={post}
                                  comment={child}
                                  isChildComment={true}
                                  addCommentHandler={null}
                                />
                              </div>
                            )
                          })
                        : null}
                    </div>
                  )
                })
            : commentsPagination.comments
                .sort(function (a, b) {
                  return (
                    moment(b.created_at).unix() - moment(a.created_at).unix()
                  )
                })
                .reverse()
                .slice(0, 3)
                .map((comment) => {
                  return (
                    <div key={comment.id}>
                      <SingleComment
                        post={post}
                        key={`single-comment-${comment.id}`}
                        comment={comment}
                        isChildComment={false}
                        addCommentHandler={addCommentHandler}
                      />
                      <p
                        className={`${styles.toggleSubComments} cursor-pointer`}
                        onClick={() => toggleShowSubComments(comment)}
                      >
                        {comment.show_sub_comments === undefined ||
                        !comment.show_sub_comments
                          ? formatShowSubCommentsButtonText(comment)
                          : formatHideSubCommentsButtonText(comment)}
                      </p>
                      {comment &&
                      comment.childs &&
                      comment.childs.length &&
                      comment.show_sub_comments
                        ? comment.childs.map((child) => {
                            return (
                              <div
                                className="flex items-center"
                                key={`child-comment-${child.id}`}
                              >
                                <SingleComment
                                  post={post}
                                  comment={child}
                                  isChildComment={true}
                                  addCommentHandler={null}
                                />
                              </div>
                            )
                          })
                        : null}
                    </div>
                  )
                })}
        </InfiniteScroll>
      </div>
      <AddComment addCommentHandler={addCommentHandler} />
    </div>
  )
}

const mapStateToProps = (state) => ({
  commentsPagination: state.commentsPagination,
})

const mapDispatchToProps = (dispatch) => {
  return {
    updateCommentsPagination: (comments, page) => {
      dispatch({
        type: actions.UPDATE_COMMENTS_PAGINATION,
        payload: {
          comments,
          page,
        },
      })
    },
    newCommentAdded: (comment) => {
      dispatch({
        type: actions.COMMENT_ADDED,
        payload: {
          comment,
        },
      })
    },
    displaySignupForm: () =>
      dispatch({
        type: actions.SHOW_SIGNUP_MODAL,
      }),
    toggleShowSubComments: (comment) =>
      dispatch({
        type: actions.TOGGLE_SHOW_SUB_COMMENTS,
        payload: {
          id: comment.id,
        },
      }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Comments)
